(function () {
  const CARD_SELECTOR = '[data-atj-product-card]';
  const WIDTHS = [165, 360, 533, 720, 940, 1066];

  function normalizeImageUrl(url) {
    if (!url) return '';
    try {
      const parsed = new URL(url, window.location.origin);
      return `${parsed.origin}${parsed.pathname}`;
    } catch (error) {
      return url.split('&width=')[0].split('?width=')[0].split('?v=')[0];
    }
  }

  function buildSrcset(baseUrl) {
    const cleanUrl = normalizeImageUrl(baseUrl);
    if (!cleanUrl) return '';
    return WIDTHS.map((width) => {
      const separator = cleanUrl.includes('?') ? '&' : '?';
      return `${cleanUrl}${separator}width=${width} ${width}w`;
    }).join(', ');
  }

  function setImage(img, url, alt) {
    if (!img || !url) return;
    const cleanUrl = normalizeImageUrl(url);
    const separator = cleanUrl.includes('?') ? '&' : '?';
    img.src = `${cleanUrl}${separator}width=533`;
    img.srcset = buildSrcset(cleanUrl);
    if (alt) img.alt = alt;
    img.removeAttribute('hidden');
  }

  function readVariantData(card) {
    const script = card.querySelector('[data-atj-variant-data]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('Atjaunojies collection card: invalid variant JSON', error);
      return null;
    }
  }

  function findVariantEntry(variantData, variantId) {
    if (!variantData?.variants?.length) return null;
    return variantData.variants.find((entry) => String(entry.id) === String(variantId)) || null;
  }

  function cacheDefaultSecondary(card) {
    if (card.dataset.atjDefaultSecondary) return card.dataset.atjDefaultSecondary;

    let url = normalizeImageUrl(card.getAttribute('data-default-secondary') || '');
    if (!url) {
      const secondaryImg = card.querySelector('.atj-product-card__image--secondary');
      url = normalizeImageUrl(secondaryImg?.getAttribute('src') || '');
    }

    if (url) card.dataset.atjDefaultSecondary = url;
    return url || '';
  }

  function resolveSecondaryUrl(card, secondaryImg, requestedUrl) {
    const primaryImg = card.querySelector('.atj-product-card__image--primary');
    const primaryUrl = normalizeImageUrl(primaryImg?.getAttribute('src') || '');
    const requested = normalizeImageUrl(requestedUrl || '');
    const existing = normalizeImageUrl(secondaryImg?.getAttribute('src') || '');
    const fallback = cacheDefaultSecondary(card);

    if (requested && requested !== primaryUrl) return requested;
    if (existing && existing !== primaryUrl) return existing;
    if (fallback && fallback !== primaryUrl) return fallback;

    return '';
  }

  function setSecondaryState(card, secondaryImg, secondaryUrl, alt) {
    if (!secondaryImg) return;

    const resolvedUrl = resolveSecondaryUrl(card, secondaryImg, secondaryUrl);
    if (!resolvedUrl) return;

    setImage(secondaryImg, resolvedUrl, alt);
    card.classList.add('atj-product-card--has-secondary');
  }

  function updateCard(card, entry) {
    if (!entry?.primary) return;

    card.dataset.activeVariantId = entry.id;

    const primaryImg = card.querySelector('.atj-product-card__image--primary');
    setImage(primaryImg, entry.primary, entry.alt);

    const secondaryImg = card.querySelector('.atj-product-card__image--secondary');
    setSecondaryState(card, secondaryImg, entry.secondary, entry.alt);

    if (entry.url) {
      card.querySelectorAll('.atj-product-card__media-link, .atj-product-card__title a').forEach((link) => {
        link.href = entry.url;
      });
    }

    card.querySelectorAll('[data-atj-swatch]').forEach((swatch) => {
      const isActive = String(swatch.dataset.variantId) === String(entry.id);
      swatch.classList.toggle('is-active', isActive);
      swatch.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function initCard(card) {
    if (card.dataset.atjInitialized === 'true') return;
    card.dataset.atjInitialized = 'true';

    cacheDefaultSecondary(card);

    const variantData = readVariantData(card);
    if (variantData) {
      const activeSwatch =
        card.querySelector('[data-atj-swatch].is-active') || card.querySelector('[data-atj-swatch]');
      const initialId = activeSwatch?.dataset.variantId || variantData.defaultVariantId;
      const initialEntry = findVariantEntry(variantData, initialId) || variantData.variants[0];

      if (initialEntry) updateCard(card, initialEntry);

      card.querySelectorAll('[data-atj-swatch]').forEach((swatch) => {
        swatch.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const entry = findVariantEntry(variantData, swatch.dataset.variantId);
          if (entry) updateCard(card, entry);
        });
      });
      return;
    }

    if (!card.classList.contains('atj-product-card--hover-swap')) return;

    const secondaryImg = card.querySelector('.atj-product-card__image--secondary');
    setSecondaryState(card, secondaryImg, cacheDefaultSecondary(card), '');
  }

  function initAll(root = document) {
    root.querySelectorAll(CARD_SELECTOR).forEach(initCard);
  }

  let observerTimer;
  function scheduleInit(root) {
    window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(() => initAll(root), 50);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAll();

    const gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) {
      const observer = new MutationObserver(() => scheduleInit(gridContainer));
      observer.observe(gridContainer, { childList: true, subtree: true });
    }
  });

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

